import { Link } from 'react-router-dom'

import { FaFacebook } from 'react-icons/fa'
import { MdEmail } from 'react-icons/md'

export default function FooterSiteLinks ({ ...props })
{
	return (
		<div className="c-footer__services">

			<div className="c-footer__service">
				<p className="c-footer__service--title">
					Pages principales
				</p>
				<ul>
					<li className="c-footer__items--link">
						<Link to="/obseques" className="c-footer__items--link-a">
							Obsèques
						</Link>
					</li>
					<li className="c-footer__items--link">
						<Link to="/avis-de-deces" className="c-footer__items--link-a">
							Avis de décès
						</Link>
					</li>
					<li className="c-footer__items--link">
						<Link to="/marbrerie" className="c-footer__items--link-a">
							Marbrerie
						</Link>
					</li>
					<li className="c-footer__items--link">
						<Link to="/contrats-obseques" className="c-footer__items--link-a">
							Contrat obsèques
						</Link>
					</li>
				</ul>
			</div>

			<div>

				<ul className="c-footer__services--infos">

					<p className="c-footer__service--title">Contact</p>

					<li className="c-footer__items--link u-margin-top-10">
						<a href="mailto:contact@sotraf.fr"
							className="c-footer__items--link-a u-no-margin-top">
							<MdEmail className="c-footer__items--ico" />
							contact@sotraf.fr
						</a>
					</li>

					<li className="c-footer__items--link">

						<a href="https://www.facebook.com/people/Sotraf/100083626741536"
							className="c-footer__items--link-a">
							<FaFacebook className="c-footer__items--ico" />
							Notre page Facebook
						</a>
					</li>

				</ul>

			</div>

		</div>
	);
}